var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "router-transitions"
  }, [_c('div', {
    staticClass: "cui-example cui-example-vertical-spacing"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('img', {
    staticStyle: {
      "height": "20rem",
      "margin": "10% auto"
    },
    attrs: {
      "src": _vm.img
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticStyle: {
      "margin": "10%"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.header)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])])])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }